var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        ref: "table-stock-counting-divergences",
        staticClass: "mb-1 bordered",
        attrs: {
          responsive: "",
          "show-empty": "",
          striped: "",
          "empty-text": _vm.getEmptyTableMessage(
            _vm.$tc("STOCK_COUNTING.NAME"),
            "female",
            _vm.queryExecuted
          ),
          fields: _vm.fields,
          items: _vm.items,
        },
        scopedSlots: _vm._u([
          {
            key: "cell(action)",
            fn: function (row) {
              return [
                _c("e-grid-actions", {
                  attrs: {
                    "show-update": false,
                    "show-delete": false,
                    "show-read-only": _vm.$can("Read", "StockCounting"),
                  },
                  on: {
                    "read-only": function ($event) {
                      return _vm.$emit("read-only", row.item)
                    },
                  },
                }),
              ]
            },
          },
          {
            key: "cell(divergentSkusPercent)",
            fn: function (ref) {
              var item = ref.item
              return [
                _c(
                  "b-badge",
                  { attrs: { variant: _vm.divergenceVariant(item) } },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("percentage")(item.divergentSkusPercent, 1)
                        ) +
                        " "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "cell(skus)",
            fn: function (ref) {
              var item = ref.item
              return [
                _vm._v(
                  " " +
                    _vm._s(item.divergentSkus) +
                    " / " +
                    _vm._s(item.countedSkus) +
                    " "
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c("e-pagination-summary", {
                attrs: {
                  "current-page": _vm.paging.currentPage,
                  "per-page": _vm.paging.pageSize,
                  total: _vm.paging.rowCount,
                  "total-on-page": _vm.paging.rowsInCurrentPage,
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c("b-pagination", {
                attrs: {
                  value: _vm.paging.currentPage,
                  align: "right",
                  "total-rows": _vm.paging.rowCount,
                  "per-page": _vm.paging.pageSize,
                  "aria-controls": "table-stock-counting-divergences",
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("page-change", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }